import React, {useCallback, useMemo} from "react";
import {
    UserExamStatus,
    UserExamStatusSelectedValue,
    UserLevels,
} from "../../../../containers/RegistrationLoginPage/types";
import {WithTitleField} from "../Styled";
import {
    composeValidators,
    regRequiredValidate,
    validateLevelForExamStatus,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import useExamStatusHandler from "../../../../hooks/useExamStatusHandler";
import RadioGroupWrapper from "../../../HTMLEntities/RadioGroupWrapper";

interface ExamStatusInterface {
    configuration: UserExamStatus;
    level: UserLevels | undefined | null;
}

const ExamStatus: React.FC<ExamStatusInterface> = ({configuration, level}: ExamStatusInterface) => {
    const examStatusCallback = useExamStatusHandler();
    const onChangeCallback = useCallback(
        (events: React.ChangeEvent<HTMLInputElement>) => {
            const examStatus = events.target.value as UserExamStatusSelectedValue;
            examStatusCallback(examStatus);
        },
        [examStatusCallback],
    );

    return useMemo(() => {
        return (
            <WithTitleField titleFieldOnLayer>
                <h3>Have you given any study abroad exam?</h3>
                <RadioGroupWrapper<UserExamStatus, UserExamStatusSelectedValue>
                    fieldData={configuration}
                    validate={composeValidators(
                        regRequiredValidate("Please select exam status"),
                        validateLevelForExamStatus(level),
                    )}
                    onChangeCallback={onChangeCallback}
                />
            </WithTitleField>
        );
    }, [onChangeCallback, configuration, level]);
};

export default ExamStatus;
